/* eslint-disable no-shadow */

export enum StepperKeysEnum {
  DELIVERY_TYPE = 'DELIVERY_TYPE',
  MENU = 'MENU',
  OVERVIEW = 'OVERVIEW',
  ORDER_DETAILS = 'ORDER_DETAILS',
}

export type OrderingStepperState = {
  step: StepperKeysEnum;
};

export type NextStepPayload = {
  nextStep: StepperKeysEnum;
};
